// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @28.05.2021 13:27:19

import { CAnimalBase_abstract } from './../abstract/SagaSchema/CAnimalBase_abstract';

export class CAnimalBase extends CAnimalBase_abstract {
  get icon(): string {
    return 'paw';
  }
}
